import { getSubjectListApi } from "@/api/services/admin/learning-content";
import { TGetSubjectListReqDto } from "@/api/services/admin/learning-content/dtos/get-subject-list.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching subject list for an industry
 * Uses React Query for caching and automatic refetching
 */
export const useSubjectList = (industryId: number | string | undefined, params?: Omit<TGetSubjectListReqDto, "industryId">) => {
  const isValidId = !!industryId && !isNaN(Number(industryId));

  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_SUBJECT_LIST, industryId, params],
    queryFn: () =>
      getSubjectListApi({
        industryId: Number(industryId),
        ...params,
      }),
    enabled: isValidId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
